import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import { commonColors } from "application/theme";

interface InputStyledProps {
  error: boolean;
  filled: boolean;
}

export const Wrapper = styled("div")`
  width: 100%;
  position: relative;
`;

export const InputStyled = styled(TextField)<InputStyledProps>`
  width: 100%;
  font-size: 12px;

  .MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-colorPrimary.Mui-focused.MuiInputBase-formControl {
    input {
      background: ${({ error }) => (error ? commonColors.error3 : commonColors.blue50)};
    }
  }

  textarea {
    min-height: 100px;
    max-height: 100px;
    padding: 12px 16px;
    border-radius: 8px;
    box-sizing: border-box;
    background: ${({ error }) => (error ? commonColors.error3 : commonColors.white)};
    /* font */
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.08px;
    color: ${commonColors.grey900};
  }

  .MuiOutlinedInput-root {
    padding: 0 !important;
  }

  .MuiInputLabel-root {
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.08px;
    color: ${commonColors.grey500};

    .MuiInputLabel-formControl {
      font-size: 12px;
      font-weight: 400;
      line-height: 130%;
      letter-spacing: 0.06px;
    }

    &.Mui-focused {
      transform: translate(14px, -8px) scale(0.75);
      color: ${({ error }) => (error ? commonColors.red700 : commonColors.blue700)};
    }
  }

  .MuiOutlinedInput-notchedOutline {
    font-size: 12px;
    border-radius: 8px;
    color: ${commonColors.grey700};
    border: 1px solid
      ${({ error, filled }) =>
        error ? commonColors.red700 : filled ? commonColors.grey700 : commonColors.grey300};

    legend {
      font-size: unset;
    }
  }

  .Mui-focused .MuiOutlinedInput-notchedOutline {
    color: ${commonColors.grey700};
    border: 1px solid ${({ error }) => (error ? commonColors.red700 : commonColors.blue700)} !important;
  }
`;

export const ErrorMessage = styled("p")`
  margin-top: 4px;
  /* font */
  font-size: 14px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: 0.07px;
  color: ${commonColors.red700};
`;
